export const PLACEHOLDER_LENGTHS = {
  ALGORITHMS: 6,
  OPERATIONS: 6,
  TECHNIQUES: 8,
  MACHINE_LEARNING: 8,
  AREAS: 12,
} as const;
